import styled from '@emotion/styled'
import MuiInputLabel from '@mui/material/InputLabel'

export const InputLabel = styled(MuiInputLabel)`
  font-size: 16px;
  font-weight: 400;
`
